const colorHexMap = {
	"Black": ["#000000", "#FFFFFF"],
	"White": ["#FFFFFF", "#000000"],
	"Blue": ["#0000FF", "#FFFFFF"],
	"Red": ["#FF0000", "#FFFFFF"],
	"Purple": ["#800080", "#FFFFFF"],
	"Gold": ["#FFD700", "#000000"],
	"Silver": ["#C0C0C0", "#000000"],
	"Yellow": ["#FFFF00", "#000000"]
};

let bgHex = null;
let fontHex = null;

window.addEventListener("load", () => {
	const polling = setInterval(() => {
		const engravingOption = document.querySelector(".hulkapps_option.rb_render > div[aria-label='Engraving'] + div input[type='hidden']");
		console.log('engravingOption-->', engravingOption);
		if (engravingOption) {
			clearInterval(polling);

			const observer = new MutationObserver(() => {
				if (engravingOption.getAttribute("value").includes("Different")) {
					document.querySelector(".engraving_container").style.display = "block";
					document.querySelectorAll(".engraving_repeat").forEach(rpt => rpt.style.display = "block");

					const engravingTitle = document.querySelector(".engraving_title");
					engravingTitle.textContent = "Engraving 1 of 1"
					engravingTitle.style.display = "block";
				} else {
					document.querySelector(".engraving_container").style.display = "none";
					document.querySelectorAll(".engraving_repeat").forEach(rpt => rpt.style.display = "none");

					const engravingTitle = document.querySelector(".engraving_title");
					engravingTitle.textContent = "Engraving for All";
					engravingTitle.style.display = "block";
				}
			});

			observer.observe(engravingOption, { attributes: true, attributeFilter: ["value"] });

			const form = engravingOption.closest("form");
			const optionSet = form.querySelector(".hulkapps_option_set");

			const engravingContainer = document.createElement("div");
			engravingContainer.className = "engraving_container";
			optionSet.appendChild(engravingContainer);

			const quantityInput = form.querySelector("input[name='quantity']");
			quantityInput.addEventListener("change", e => {
				const engravingDifferentList = optionSet.querySelectorAll(".engraving_different");
				const len = engravingDifferentList.length / 3 + 1;

				if (e.target.value === len) return;
				else if (e.target.value > len) {
					document.querySelectorAll(".engraving_title").forEach((title, i) => {
						title.textContent = `Engraving ${i + 1} of ${e.target.value}`;
					});
					createNewEngravingOptions(engravingContainer, e.target.value - len, e.target.value, len);
				} else {
					deleteExistingEngravingOptions(engravingContainer, len - e.target.value, e.target.value, len);
				}

				updatePrices(e.target.value);
			});

			// const colorSelect = optionSet.querySelector(".hulkapps_option.dd_render select[aria-label='Color of Polydomed Plate']");
			// colorSelect.addEventListener("change", (e) => {
			// 	const selectedValue = e.target.value;
			// 	if (selectedValue) {
			// 		const colorName = selectedValue.split(" with ")[0].trim();
			// 		bgHex = colorHexMap[colorName][0] || null;
			// 		fontHex = colorHexMap[colorName][1] || null;
			// 		optionSet.querySelector(".color_showcase").style.backgroundColor = bgHex;
			// 		optionSet.querySelectorAll(".engraving_preview").forEach(pr => {
			// 			pr.style.backgroundColor = bgHex;
			// 			pr.style.color = fontHex;
			// 		});
			// 	} else {
			// 		console.log("No color selected");
			// 	}
			// });

			// const colorSelectTitle = colorSelect.parentElement.previousElementSibling;
			// const newColorDiv = document.createElement("div");
			// newColorDiv.className = "color_showcase";
			// colorSelectTitle.appendChild(newColorDiv);

				
			function handleColorChange(rawColorValue) {
				if (!rawColorValue) return;

				let colorName = rawColorValue.split(" with ")[0].split("[")[0].trim();
			
				if (colorName.startsWith("Solid ")) {
					colorName = colorName.replace("Solid ", "").trim();
				}
				
				if (colorName.includes("Blue")) colorName = "Blue";
				if (colorHexMap[colorName]) {
					bgHex = colorHexMap[colorName][0];
					fontHex = colorHexMap[colorName][1];

					optionSet.querySelectorAll(".color_showcase").forEach(showcase => {
						showcase.style.backgroundColor = bgHex;
					});

					const previews = optionSet.querySelectorAll(".engraving_preview");
					if(previews.length > 0) {
						previews.forEach(pr => {
							pr.style.setProperty('background-color', bgHex, 'important');
							pr.style.setProperty('color', fontHex, 'important');
						});
						console.log(`HulkApps Debug: Updated ${previews.length} preview containers.`);
					} else {
						console.log("HulkApps Debug: No .engraving_preview containers found in DOM yet.");
					}
				} else {
					console.log("HulkApps Debug: Color NOT found in colorHexMap ->", colorName);
				}
			}

			// ========================================================
			// ૨. "Color of Polydomed Plate" 
			// ========================================================
			const colorSelect = optionSet.querySelector(".hulkapps_option.dd_render select[aria-label='Color of Polydomed Plate']");
			if (colorSelect) {
				colorSelect.addEventListener("change", (e) => {
					handleColorChange(e.target.value);
				});

				const colorSelectTitle = colorSelect.closest(".hulkapps_option").querySelector(".hulkapps_option_name");
				if (colorSelectTitle && !colorSelectTitle.querySelector(".color_showcase")) {
					const newColorDiv = document.createElement("div");
					newColorDiv.className = "color_showcase";
					colorSelectTitle.appendChild(newColorDiv);
				}
			}

			// ========================================================
			// ૩. "Neck Ribbon Color"
			// ========================================================
			const ribbonOptionContainer = optionSet.querySelector(".hulkapps_option.swatch_render");
			if (ribbonOptionContainer) {
				
				ribbonOptionContainer.addEventListener("click", function(e) {
					const targetSwatch = e.target.closest(".hulkapps_swatch_option, .hulk_po_radio");
					if (targetSwatch) {
						const radioInput = targetSwatch.querySelector("input[type='radio']") || targetSwatch;
						const swatchValue = radioInput.getAttribute("value");
						
						if (swatchValue) {
							setTimeout(() => {
								handleColorChange(swatchValue);
							}, 50);
						}
					}
				});

				const ribbonTitle = ribbonOptionContainer.querySelector(".hulkapps_option_name");
				if (ribbonTitle && !ribbonTitle.querySelector(".color_showcase")) {
					const newColorDiv = document.createElement("div");
					newColorDiv.className = "color_showcase";
					ribbonTitle.appendChild(newColorDiv);
				}
			}


			const engravingLineList = optionSet.querySelectorAll(".hulkapps_option.tb_render:has(div[aria-label^='Line'])");
			engravingLineList.forEach((element, index) => {
				if (index === 0) {
					const newOptionTitle = document.createElement("h2");
					newOptionTitle.textContent = "Engraving for All";
					newOptionTitle.className = "engraving_title";
					element.parentElement.insertBefore(newOptionTitle, element);
				}

				const newEngravingPreview = document.createElement("div");
				newEngravingPreview.className = `engraving_preview engraving_preview_${index + 1}`;
				element.appendChild(newEngravingPreview);

				element.querySelector("input[type='text']").addEventListener("input", e => {
					newEngravingPreview.textContent = e.target.value;
				});

				const newRepeatBtn = document.createElement("button");
				newRepeatBtn.textContent = "Repeat";
				newRepeatBtn.className = "engraving_repeat";
				newRepeatBtn.setAttribute("data-active", "false");
				element.querySelector(".hulkapps_option_value").appendChild(newRepeatBtn);

				newRepeatBtn.addEventListener("click", e => {
					e.preventDefault();

					const val = element.querySelector("input[type='text']").value;
					if (e.target.getAttribute("data-active") == "true") {
						document.querySelectorAll(`.hulkapps_option.engraving_different > .hulkapps_option_name[aria-label="Line ${index + 1}"] + div input`).forEach(input => {
							input.value = "";
						});
						document.querySelectorAll(`.hulkapps_option.engraving_different > .hulkapps_option_name[aria-label="Line ${index + 1}"] + div + div`).forEach(preview => {
							preview.textContent = "";
						});
						e.target.setAttribute("data-active", "false");
					} else {
						document.querySelectorAll(`.hulkapps_option.engraving_different > .hulkapps_option_name[aria-label="Line ${index + 1}"] + div input`).forEach(input => {
							input.value = val;
						});
						document.querySelectorAll(`.hulkapps_option.engraving_different > .hulkapps_option_name[aria-label="Line ${index + 1}"] + div + div`).forEach(preview => {
							preview.textContent = val;
						});
						e.target.setAttribute("data-active", "true");
					}
				});
			});

			// const optionsContainer = optionSet.closest("div[id^='hulkapps_custom']");
			// optionsContainer.parentNode.insertBefore(createPricingOverview({
			// 	subtotal: '$29.00',
			// 	addon: '$00.00',
			// 	total: '$29.00'
			// }), optionsContainer.nextSibling);

			setTimeout(() => updatePrices(document.querySelector("input[name='quantity']").value), 50);
		}
	}, 100);

	setTimeout(() => clearInterval(polling), 20000);

	document.querySelectorAll(".variant-input-wrap .variant-input input").forEach(input => {
		input.addEventListener("change", e => setTimeout(() => updatePrices(document.querySelector("input[name='quantity']").value), 50));
	});
});

function createNewEngravingOptions(optionSet, num, quantity, len) {
	for (let i = 0; i < num; i++) {
		for (let j = 0; j < 3; j++) {
			const wrapper = document.createElement("div");
			wrapper.className = "hulkapps_option tb_render full_width engraving_different";

			if (j === 0) {
				const newOptionTitle = document.createElement("h2");
				newOptionTitle.textContent = `Engraving ${len + i + 1} of ${quantity}`;
				newOptionTitle.className = "engraving_title";
				newOptionTitle.style.display = "block";
				wrapper.appendChild(newOptionTitle);
			}

			const labelDiv = document.createElement("div");
			labelDiv.className = "hulkapps_option_name";
			labelDiv.setAttribute("aria-label", `Line ${j + 1}`);
			labelDiv.setAttribute("tabindex", "0");
			labelDiv.setAttribute("aria-required", "false");

			const labelInner = document.createElement("div");
			labelInner.textContent = `Line ${j + 1}`;

			labelDiv.appendChild(labelInner);

			const valueDiv = document.createElement("div");
			valueDiv.className = "hulkapps_option_value";

			const input = document.createElement("input");
			input.type = "text";
			input.className = "hulkapps_option_child hulk_po_other_options hulkapps_full_width price-change";
			input.setAttribute("data-parent", "hulkapps_product_options");
			input.setAttribute("data-pid", "8570396704935");
			input.setAttribute("data-price", "0.00");
			input.maxLength = 16;
			input.addEventListener("input", e => {
				console.log(e.target.value)
				newEngravingPreview.textContent = e.target.value;
			});

			const hidden1 = document.createElement("input");
			hidden1.type = "hidden";
			hidden1.name = `properties[Line ${j + 1}_${len + i + 1}]`;
			hidden1.className = "tb_property_val other_options_prop_val";

			const hidden2 = document.createElement("input");
			hidden2.type = "hidden";
			hidden2.value = "16";
			hidden2.className = "character_count";

			// Char count div
			const charCount = document.createElement("div");
			charCount.id = "char_count_1604792";
			charCount.textContent = "16 Characters remaining";

			// Script tag
			const script = document.createElement("script");
			script.textContent = `(function($) {
				$(document).on('input', '.hulkapps_product_options .hulkapps_option_1604792', function() {
					check_character_limit(16,'1604792','Characters remaining','hulkapps_product_options');
				});
				}(hulkapps_jQuery))`;

			const newEngravingPreview = document.createElement("div");
			newEngravingPreview.className = `engraving_preview engraving_preview_${j + 1}`;
			newEngravingPreview.style.backgroundColor = bgHex;
			newEngravingPreview.style.color = fontHex;

			valueDiv.appendChild(input);
			valueDiv.appendChild(hidden1);
			valueDiv.appendChild(hidden2);
			valueDiv.appendChild(charCount);
			valueDiv.appendChild(script);

			wrapper.appendChild(labelDiv);
			wrapper.appendChild(valueDiv);

			wrapper.appendChild(newEngravingPreview);

			optionSet.appendChild(wrapper);
		}
	}
}

function deleteExistingEngravingOptions(optionSet, num) {
	const engravingDifferentList = optionSet.querySelectorAll(".engraving_different");
	const toRemove = num * 3;

	for (let i = 0; i < toRemove; i++) {
		const last = engravingDifferentList[engravingDifferentList.length - 1 - i];
		if (last) last.remove();
	}
}

function createPricingOverview({
	subtotal = '',
	addon = '',
	total = ''
} = {}) {
	const wrapper = document.createElement("div");
	wrapper.className = "pricing_overview";

	// Helper to build row
	function makeRow(label, value, className) {
		const row = document.createElement("div");
		row.className = className;

		const labelDiv = document.createElement("div");
		labelDiv.textContent = label;

		const valueDiv = document.createElement("div");
		valueDiv.textContent = value;

		row.appendChild(labelDiv);
		row.appendChild(valueDiv);

		return row;
	}

	// Rows
	const subtotalRow = makeRow("Subtotal Price", subtotal, "subtotal-price");
	const addonRow = makeRow("Customization/Setup Charges", addon, "addon-price");
	const totalRow = makeRow("Total Price", total, "total-price");

	wrapper.appendChild(subtotalRow);
	wrapper.appendChild(addonRow);
	wrapper.appendChild(totalRow);

	return wrapper;
}

function getDiscountedPrice(quantity) {
	const tierElements = document.querySelectorAll(".variant-input-wrap .variant-input:has(input:checked) + div > div");

	for (const el of tierElements) {
		const lines = el.innerText.trim().split("\n").map(t => t.trim());
		if (lines.length < 2) continue;

		const rangeText = lines[0]; // e.g. "2-4" or "100+"
		const priceText = lines[1]; // e.g. "$9.50"

		// Parse price
		const price = parseFloat(priceText.replace("$", ""));

		let min, max;

		if (rangeText.includes("-")) {
			// e.g. "2-4"
			const [low, high] = rangeText.split("-").map(Number);
			min = low;
			max = high;
		} else if (rangeText.includes("+")) {
			// e.g. "100+"
			min = parseInt(rangeText);
			max = Infinity;
		} else {
			// Single number like "1"
			min = parseInt(rangeText);
			max = min;
		}

		// Check if quantity falls into this tier
		if (quantity >= min && quantity <= max) {
			return price * quantity;
		}
	}

	return null;
}

function updatePrices(quantity) {
	// const pricingOverview = document.querySelector(".pricing_overview");
	const price = getDiscountedPrice(quantity);

	// pricingOverview.querySelector(".subtotal-price > div:nth-child(2)").textContent = formatPrice(price);
	// pricingOverview.querySelector(".addon-price > div:nth-child(2)").textContent = formatPrice(price);
	// pricingOverview.querySelector(".total-price > div:nth-child(2)").textContent = formatPrice(price);
	
	const atcBtn = document.querySelector(".add-to-cart.hulkapps_submit_cart span");
	const money = atcBtn.querySelector("span.money");
	if (money) {
		money.textContent = formatPrice(price);
	} else {
		atcBtn.innerHTML += `<span>●</span><span class="money">${formatPrice(price)}</span>`;
	}
}

function formatPrice(price) {
	return price?.toLocaleString(Shopify.locale + '-' + Shopify.country, {
		style: 'currency',
		currency: Shopify.currency.active
	}).replace(/^.*\$/, "$");
}